import React from "react";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {SUB_VIEW_MODEL} from "../../Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Header of the requests tab.
 *
 * Holds the buttons that move between the requests in course and the history of
 * the requests that already ended, and the simple search of the sub view that
 * is being read.
 */
export const MaterialRequestHeader = ({
    optionView,
    handleBtnRequest,
    handleBtnHistory,
    searchId,
    setBodyForExport,
    setResults,
    results,
    searchElement,
    setSearchElement,
    option,
    rowsPerPage,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    getData
}) => {
    return (
        <div className='d-flex gap-2 mb-2'>
            <ButtonAction
                id='btn_mrh_requests'
                name='requested_forms'
                className={
                    SUB_VIEW_MODEL.REQUESTS.REQUEST === optionView
                        ? 'btn-outlined-secondary-600-100'
                        : 'btn-outlined-secondary-600-00'
                }
                disabled={false}
                splitName={false}
                onClick={() => {
                    handleBtnRequest();
                }}
            />
            <ButtonAction
                id='btn_mrh_history'
                name='history'
                className={
                    SUB_VIEW_MODEL.REQUESTS.HISTORY === optionView
                        ? 'btn-outlined-secondary-600-100'
                        : 'btn-outlined-secondary-600-00'
                }
                disabled={false}
                splitName={false}
                onClick={() => {
                    handleBtnHistory();
                }}
            />

            <div className='flex-grow-1'>
                <SearchSimple
                    id={searchId}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={null}
                    supplierId={null}
                    // The simple search drops the filters of the advanced search, so the
                    // export goes back to the simple endpoint along with the table
                    callApi={getData ? () => {
                        setSearch(false);
                        getData(0, {searchElement});
                    } : undefined}
                    resetApi={getData ? () => {
                        setSearch(false);
                        getData(0, {searchElement: ''});
                    } : undefined}
                />
            </div>
        </div>
    );
};
